const ONE_MINUTE_MS = 60000;

export enum DurationMs {
  THIRTY_SEC = ONE_MINUTE_MS / 2,
  MINUTE = ONE_MINUTE_MS,
  FIVE_MIN = 5 * ONE_MINUTE_MS,
  FIFTEEN_MIN = 15 * ONE_MINUTE_MS,
  THIRTY_MIN = 30 * ONE_MINUTE_MS,
  FORTY_FIVE_MIN = 45 * ONE_MINUTE_MS,
  ONE_HOUR = 60 * ONE_MINUTE_MS,
  FOREVER = Infinity,
}

const ONE_MINUTE = 60;

export enum Duration {
  THIRTY_SEC = ONE_MINUTE / 2,
  MINUTE = ONE_MINUTE,
  FIVE_MIN = 5 * ONE_MINUTE,
  FIFTEEN_MIN = 15 * ONE_MINUTE,
  THIRTY_MIN = 30 * ONE_MINUTE,
  FORTY_FIVE_MIN = 45 * ONE_MINUTE,
  ONE_HOUR = 60 * ONE_MINUTE,
  FOREVER = Infinity,
}
